import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "../i18n";

const PollForm = ({ 
  selectedGame, 
  pollTitle, 
  pollText, 
  tags, 
  isPublic, 
  pollOptions, 
  pollDuration, 
  setPollTitle, 
  setPollText, 
  setSelectedTags, 
  setSelectedGame, 
  setIsPublic, 
  setPollOptions, 
  setPollDuration,
  isEdited,
}) => {
  const [pollMessage, setPollMessage] = useState("");
  const navigate = useNavigate();

  const submitHandler = (event) => {
    event.preventDefault();

    if (!pollTitle.trim() || !pollText.trim() || pollOptions.some(choice => !choice.trim())) {
      setPollMessage("All fields must be filled, and poll must have at least two options.");
      return;
    }

    const requestBody = {
      authorID: sessionStorage.getItem("user"),
      content: pollText,
      attributes: {
        title: pollTitle,
        tags: Array.isArray(tags) ? tags : [],
        game: selectedGame || "",
        choices: Array.isArray(pollOptions) ? pollOptions : [],
        visibility: isPublic ? "public" : "private",
        duration: pollDuration,
        startDate: new Date().toISOString(), // Capture the current date/time
        endDate: pollDuration 
        ? new Date(Date.now() + pollDuration * 24 * 60 * 60 * 1000).toISOString() 
        : null, // Calculate end date based on duration
        votedUsers: [],
        voteCount: pollOptions.reduce((acc, option) => {
            acc[option] = 0; // Initialize each choice with 0 votes
            return acc;
          }, {}),
        letedited: isEdited,
      },
    };

    console.log("Sending Poll Request:", requestBody);

    fetch(`${process.env.REACT_APP_API_PATH}/posts`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("Poll Created:", result);
        setPollTitle("");
        setPollText("");
        setPollDuration("");
        setPollOptions(["", ""]);
        setSelectedTags([]);
        setSelectedGame("");
        navigate("/");
      })
      .catch((error) => {
        console.error("Error creating poll:", error);
        setPollMessage("Error creating poll! Please try again.");
      });
  };

  return (
    <div>
      <form onSubmit={submitHandler}>
        <button  className="poll-button" type="submit" >{t("create")}</button>
        {pollMessage && <p className="error-message">{pollMessage}</p>}
      </form>
    </div>
  );
};

export default PollForm;
